import { motion, Variants } from "motion/react";
import { memo, useMemo } from "react";

interface AnimatedLogoTextProps {
  logoText: string;
}

const containerVariant: Variants = {
  initial: {
    transition: {
      ease: "easeOut",
      duration: 0.3
    }
  },
  hover: {
    transition: {
      duration: 0.3
    }
  }
};

const letterVariant: Variants = {
  initial: {
    y: 0,
    transition: {
      type: "tween",
      ease: "easeOut",
      duration: 0.3
    }
  },
  hover: {
    y: -7,
    transition: {
      type: "spring",
      damping: 12,
      stiffness: 200,
      mass: 0.2
    }
  }
};

export const AnimatedLogoText = memo(({ logoText }: AnimatedLogoTextProps) => {
  const letters = useMemo(() => [...logoText], [logoText]);

  return (
    <motion.div variants={containerVariant} initial="initial" whileHover="hover" animate="initial" className="flex">
      {letters.map((letter, index) => (
        <motion.span
          key={`${index}-${letter}`}
          initial="initial"
          whileHover="hover"
          animate="initial"
          variants={letterVariant}
          className="inline-block origin-bottom cursor-default transition duration-300 ease-out"
        >
          {letter}
        </motion.span>
      ))}
    </motion.div>
  );
});

AnimatedLogoText.displayName = "AnimatedLogoText";
